import { Links, LinksProps, LinksVariant } from ".";
import React from "react";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";

export class LinksInterface
  extends ComponentInterfaceBaseClass
  implements LinksProps
{
  children?: any;
  variant?: LinksVariant;
  onDark?: boolean;
  appsDownload?: string;
  linkName?: string;
  nextLink?: boolean;
  href?: any;
  props?: React.AnchorHTMLAttributes<HTMLAnchorElement> = {};
  overlay?: boolean;
  isModal?: boolean;
  modalChildren?: any;
  modalSize?: any;
  appleStoreAltText?: any;
  googleStoreAltText?: any;
  videoContent?: any;
  isNewTab?: boolean;
  additionalAnalyticsData?: any;
  namedLinkedAnchor?: string;
  margin?: string[];
  accessibilityText?: string;

  static initWithSanity(key, feed) {
    const t = new LinksInterface();
    t.children = feed.text;
    t.appsDownload = feed.appsDownload ? feed.appsDownload : "";
    t.appleStoreAltText = feed.appleStoreAltText;
    t.googleStoreAltText = feed.googleStoreAltText;
    if (feed.configs) {
      t.onDark = feed.configs.onDark ? feed.configs.onDark : false;
      t.variant = (feed.configs?.type || feed.configs?.variant)
        ? (feed.configs?.type || feed.configs?.variant)
        : LinksVariant.textPlain;
      t.nextLink = feed.configs.nextLink ? feed.configs.nextLink : false;
      t.overlay = feed.configs.overlay ? feed.configs.overlay : false;
      t.isModal = feed.configs?.function === "modal" ? true : false;
      t.isNewTab = feed.configs?.function === "newtab" ? true : false;
    }
    t.href = feed.href;
    if (feed.accessibilityText) {
      t.accessibilityText = feed.accessibilityText;
      t.linkName = feed.accessibilityText;
    }
    const modalContent = feed?.modalContent;
    t.videoContent = feed?.videoBackgroundData;
    t.modalChildren = { modalContent };
    t.additionalAnalyticsData = feed?.additionalAnalyticsData;
    t.margin = feed?.margin ? feed.margin : [];
    t.namedLinkedAnchor = feed?.namedLinkedAnchor;
    return t;
  }

  toProps(): LinksProps {
    return {
      children: this.children,
      appsDownload: this.appsDownload,
      variant: this.variant,
      overlay: this.overlay,
      href: this.href,
      isModal: this.isModal,
      modalChildren: this.modalChildren,
      videoContent: this.videoContent,
      appleStoreAltText: this.appleStoreAltText,
      googleStoreAltText: this.googleStoreAltText,
      isNewTab: this.isNewTab,
      additionalAnalyticsData: this.additionalAnalyticsData,
      margin: this.margin,
      namedLinkedAnchor: this.namedLinkedAnchor,
      accessibilityText: this.accessibilityText,
      ...this.props,
    };
  }

  toJsx(): JSX.Element {
    return React.createElement(Links, {
      ...this.toProps(),
    });
  }
}
